import { mcToast } from '@/plugins/McToastAlertPlugin'
import { errorDescription } from '@/plugins/error-description-plugin'

const isErrorDescriptionsEndpoint = (e) => {
  const url = e?.config?.url || ''
  return url.includes('/error-descriptions')
}

const errorHandlerRest = (e) => {
  let errors = true
  let message = 'Bad Request'
  let data = null

  // Check for error_code_internal — if present, show the error description modal
  const errorCodeInternal = e?.response?.data?.error_code_internal
  const errorMessage = e?.response?.data?.message
  if (errorCodeInternal) {
    errorDescription.show(errorCodeInternal, {
      // Pass the original API message as subHeader fallback
      subHeader: e.response?.data?.message || '',
      body: errorMessage,
    })

    // Still return resolved promise with error data so calling code can handle it
    return Promise.resolve({
      data: {
        errors: e.response?.data?.errors || e.response?.data?.message || errors,
        status: e.response?.status,
        error_code_internal: errorCodeInternal,
      },
    })
  }

  // Cek apakah request ke endpoint error-descriptions
  const isErrorDesc = isErrorDescriptionsEndpoint(e)

  switch (e?.response?.status) {
    case 401:
      // TODO: probably need to adjust this since we are using cookies for auth
      localStorage.removeItem('token')
      localStorage.removeItem('domainName')
      localStorage.removeItem('domainNameExpired')
      localStorage.removeItem('payload')

      window.location.href = '/login'
      break

    case 400:
      if (e.response.data?.message === 'bad_request') {
        mcToast.error('Terdapat kesalahan format pada input anda')
      }

      // So usage will be:

      errors =
        (e.response?.data?.errors ||
          e.response?.data?.message ||
          e.response?.data?.details
            ?.map((detail) => `${detail.field} ${detail.message}`)
            .join(', ')) ??
        errors

      mcToast.error('Bad Request: ' + errors)

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })

    case 403:
    case 404:
      errors = e.response?.data?.errors ?? e.response?.data?.message ?? errors

      if (!isErrorDesc) mcToast.error('Not Found: ' + errors)
      return Promise.resolve({
        data: {
          errors,
          status: e.response?.status,
        },
      })
    case 409:
      errors =
        e.response?.data?.message ??
        e.response?.data?.details?.map((detail) => detail.message).join(', ') ??
        errors

      mcToast.error('Conflict: ' + errors)
      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
        },
      })

    case 500:
      data = e.response?.data
      message = e.response?.data?.message || e.response?.data?.error || message
      mcToast.error(message)
      if (data) {
        return Promise.resolve({
          data: {
            data,
            status: e.response.status,
          },
        })
      }
      break
    default:
      console.error(e)
      if (e.response?.status != undefined) {
        mcToast.error(
          `${e.response?.status} ${e.response?.data?.message || e.response?.data || e.message}`
        )
      }
  }
}

/*
 * NOTE:
 * errorHandlerRestV2 is created since we need to handle toast message from
 * parent completely, since errorHandlerRest (v1) is used in existing code,
 * removing the toast message will break the existing code.
 */
export const errorHandlerRestV2 = (e) => {
  let errors = true

  // Check for error_code_internal — if present, show the error description modal
  const errorCodeInternal = e?.response?.data?.error_code_internal
  const errorMessage = e?.response?.data?.message
  if (errorCodeInternal) {
    errorDescription.show(errorCodeInternal, {
      subHeader: e.response?.data?.message || '',
      body: errorMessage,
    })

    return Promise.resolve({
      data: {
        errors: e.response?.data?.errors || errors,
        status: e.response?.status,
        message: e.response?.data?.message,
        error_code_internal: errorCodeInternal,
      },
    })
  }

  switch (e?.response?.status) {
    case 401:
      localStorage.removeItem('token')
      localStorage.removeItem('domainName')
      localStorage.removeItem('domainNameExpired')
      localStorage.removeItem('payload')

      window.location.href = '/login'
      break

    // So usage will be:
    case 400:
    case 403:
    case 404:
    case 422:
      errors = e.response?.data?.errors ?? errors

      return Promise.resolve({
        data: {
          errors,
          status: e.response.status,
          message: e.response.data?.message,
        },
      })

    case 500:
      mcToast.error('Internal Server Error')
      break

    default:
      console.error(e)

      mcToast.error(`${e.response?.status} ${e.response?.data || e.message}`)
      return Promise.resolve({
        data: {
          errors: e.response?.data ?? errors,
          status: e.response.status,
        },
      })
  }
}

export default errorHandlerRest
